import { Translation } from '@ps/web-shared-components';
import React from 'react';

import type { BankWireResultInfo } from '../../../../../../../../types/Cashier';
import BankInfo from '../BankInfo/BankInfo';

import {
  TXTWCL_Any_incorrect_or_missing_infor_ELL,
  TXTWCL_Please_read_the_deposit_instru_ELL,
  TXTWCL_WeXve_sent_this_information_to_ELL,
  TXTWCL_When_transferring_in_your_loca_ELL,
  TXTWCL_You_have_two_weeks_to_make_the_ELL
} from './BankWire.messages.json';

interface Props {
  userEmail?: string;
  bankInfo: BankWireResultInfo;
}

const BankWire: React.FC<Props> = ({ userEmail, bankInfo }) => (
  <>
    <p>
      <Translation {...TXTWCL_Please_read_the_deposit_instru_ELL} />{' '}
      <Translation {...TXTWCL_Any_incorrect_or_missing_infor_ELL} />
    </p>
    <BankInfo bankInfo={bankInfo} />
    <p>
      <Translation
        {...TXTWCL_WeXve_sent_this_information_to_ELL}
        values={{ 0: <b>{userEmail}</b> }}
      />
      <br />
      <Translation {...TXTWCL_You_have_two_weeks_to_make_the_ELL} />
    </p>
    <Translation tagName="p" {...TXTWCL_When_transferring_in_your_loca_ELL} />
  </>
);

export default BankWire;
